module.exports = __webpack_public_path__ + "static/media/RP-56.b2c5f49a.pdf";